import { render, staticRenderFns } from "./SetupProgressBar.vue?vue&type=template&id=728cfbfb&scoped=true"
import script from "./SetupProgressBar.vue?vue&type=script&lang=js"
export * from "./SetupProgressBar.vue?vue&type=script&lang=js"
import style0 from "./SetupProgressBar.vue?vue&type=style&index=0&id=728cfbfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728cfbfb",
  null
  
)

export default component.exports